<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import IdeaInfo from "../../components/IdeaInfo.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PagePreviewColumn from "../../components/PagePreviewColumn.svelte";
    import PagePreviewContainer from "../../components/PagePreviewContainer.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import Krankenwagen from "../../icons/KrankenwagenIcon.svelte";
    import Systeme from "../../icons/SystemsIcon.svelte";
    import Funk from "../../icons/FunkIcon.svelte";
    import Alarm from "../../icons/AlarmIcon.svelte";
    import Reparaturen from "../../icons/RepairIcon.svelte";
    import Server from "../../icons/ServerIcon.svelte";
    import IconImg from "../../components/IconImg.svelte";
    import FunkIcon from "../../icons/FunkIcon.svelte";
    import KrankenwagenIcon from "../../icons/KrankenwagenIcon.svelte";
    import SystemsIcon from "../../icons/SystemsIcon.svelte";
    import RepairIcon from "../../icons/RepairIcon.svelte";
    import ServerIcon from "../../icons/ServerIcon.svelte";
    import { t } from "../../helpers/translation";
</script>

<!-- <LightTheme /> -->
<!-- <Hero headline="zuverlässig und <br>schnell" small /> -->
<Hero
    small
    slides={[
        {
            work: $t("page.values.hero.slide.1.work"),
            name: $t("page.values.hero.slide.1.name"),
            headline: $t("page.values.hero.slide.1.headline"),
            person_img:
                "https://liveicom.azureedge.net/sinus/img/members/marcus_landschof.png",
        },
    ]}
/>

<Container>
    <!-- <center> -->
    <Headline>
        {@html $t("page.values.headline")}
    </Headline>
    <Subline>
        {@html $t("page.values.subline")}
    </Subline>

    <div class="ytvideo">
        <iframe
            width="100%"
            height="100%"
            src="https://www.youtube-nocookie.com/embed/hHvOsBlMtQk?si=lj6IxMJrHNyaaNJr"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
        />
    </div>

    <p>
        {@html $t("page.values.p.1")}
    </p>
    <p>
        {@html $t("page.values.p.2")}
    </p>

    <center>
        <Gap height="6em" />
        <Subline>
            {@html $t("page.values.portfolio.subline")}
        </Subline>
        <p>
            {@html $t("page.values.portfolio.p")}
        </p>

        <div class="icon-card-container">
            <a href="loesungen/digitale-alarmierung" class="icon-card">
                <IconImg svg={Alarm} color="var(--yellow)" size="2.5em" />
                <Divider width="50%" />
                <h3>
                    {@html $t("page.values.portfolio.digitalalarm")}
                </h3>
            </a>
            <a href="loesungen/wachen-und-elw" class="icon-card">
                <IconImg
                    svg={KrankenwagenIcon}
                    color="var(--yellow)"
                    size="2.5em"
                />
                <Divider width="50%" />
                <h3>
                    {@html $t("page.values.portfolio.wachenelw")}
                </h3>
            </a>
            <a href="loesungen/leitsysteme" class="icon-card">
                <IconImg svg={SystemsIcon} color="var(--yellow)" size="2.5em" />
                <Divider width="50%" />
                <h3>
                    {@html $t("page.values.portfolio.leitsysteme")}
                </h3>
            </a>
            <a href="loesungen/reparaturen" class="icon-card">
                <IconImg svg={ServerIcon} color="var(--yellow)" size="2.5em" />
                <Divider width="50%" />
                <h3>
                    {@html $t("page.values.portfolio.repair")}
                </h3>
            </a>
            <a href="loesungen/sprach-und-datenfunk" class="icon-card">
                <IconImg svg={FunkIcon} color="var(--yellow)" size="2.5em" />
                <Divider width="50%" />
                <h3>
                    {@html $t("page.values.portfolio.sprachfunk")}
                </h3>
            </a>
            <a href="loesungen/reparaturen" class="icon-card">
                <IconImg svg={RepairIcon} color="var(--yellow)" size="2.5em" />
                <Divider width="50%" />
                <h3>
                    {@html $t("page.values.portfolio.specials")}
                </h3>
            </a>
        </div>

        <Container max="800px">
            <Gap height="4rem" />
            <div
                style="display: flex; flex-wrap: wrap; justify-content:space-around; width: 100%"
            >
                <!-- <Btn arrow href="/ueber-uns/zertifikate">Zertifikate</Btn> -->
                <Btn arrow href="ueber-uns/partner">
                    {@html $t("page.values.btn.partner")}
                </Btn>
                <Btn arrow yellow href="ueber-uns/team">
                    {@html $t("page.values.btn.team")}
                </Btn>
                <!-- <Btn href="kontakt" arrow yellow>
                    {@html $t("page.values.btn.contact")}
                </Btn> -->
            </div>
            <Gap height="4rem" />
        </Container>
    </center>
    <!-- </center> -->
</Container>

<style lang="scss">
    @import "../../vars";

    .icon-card-container {
        margin-top: 2em;
        font-size: 1.5rem;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(8em, 1fr));
        gap: 1.5em;
        max-width: 800px;
        margin: auto;
        @media (max-width: 800px) {
            font-size: 1.1rem;
        }
        // @media (max-width: 650px) {
        //     grid-template-columns: 1fr 1fr;
        // }
    }
    .icon-card {
        height: 8em;
        min-width: 8em;
        // background-color: red;
        text-align: center;
        border: 1px solid $yellow;
        border-radius: 1em;
        padding: 1em;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        flex-direction: column;
        transition: 0.1s ease-in-out;
        transform: scale(1);
        :global(svg) {
            height: 2em;
            width: auto;
        }
        &:hover {
            transform: scale(1.1);
            background-color: $green;
            border-color: $green;
            :global(*) {
                color: white !important;
                fill: white !important;
            }
        }
        h3 {
            font-size: 0.8em;
            line-height: 1.3;
            font-weight: 500;
            color: $yellow;
            margin-top: 0;
            margin-bottom: 0;
        }
    }
</style>
